import type { ResourceCategory } from '@/mocks/resources';

interface SidebarProps {
  categories: ResourceCategory[];
  activeId: string;
  savedCount: number;
  onJump: (id: string) => void;
}

const icons: Record<string, string> = {
  efficiency: 'ri-timer-flash-line',
  design: 'ri-palette-line',
  material: 'ri-image-line',
  dev: 'ri-code-s-slash-line',
  ai: 'ri-robot-2-line',
  template: 'ri-file-copy-2-line',
  learn: 'ri-book-open-line',
  useful: 'ri-stackshare-line',
};

const Sidebar = ({ categories, activeId, savedCount, onJump }: SidebarProps) => {
  return (
    <aside className="sticky top-24 hidden h-fit w-60 shrink-0 lg:block" aria-label="分类索引">
      <nav className="rounded-lg border border-background-200 bg-background-50 p-2">
        <p className="flex items-center gap-1.5 px-2 py-2 text-xs font-semibold uppercase tracking-wide text-foreground-500">
          <i className="ri-apps-2-line text-sm" aria-hidden="true" />
          分类速览
        </p>
        {categories.map((c) => {
          const isActive = c.id === activeId;
          return (
            <a
              key={c.id}
              href={`#${c.id}`}
              onClick={() => onJump(c.id)}
              aria-current={isActive ? 'true' : undefined}
              className={`mb-0.5 flex items-center gap-2.5 rounded-md px-2.5 py-2 text-sm transition-colors ${
                isActive
                  ? 'bg-primary-500 font-semibold text-background-50'
                  : 'text-foreground-800 hover:bg-background-100 hover:text-primary-700'
              }`}
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded ${
                  isActive ? 'bg-background-50/20' : 'bg-background-100 text-primary-600'
                }`}
              >
                <i className={`${icons[c.id] || 'ri-apps-2-line'} text-sm`} aria-hidden="true" />
              </span>
              <span className="flex-1">{c.name}</span>
              <span className={`text-[11px] ${isActive ? 'text-background-50/80' : 'text-foreground-500'}`}>
                {c.list.length}
              </span>
            </a>
          );
        })}
      </nav>

      <div className="mt-3 rounded-lg border border-accent-200 bg-accent-50 p-4">
        <div className="flex items-center gap-2">
          <i className="ri-bookmark-2-line text-lg text-accent-700" aria-hidden="true" />
          <p className="text-sm font-semibold text-accent-900">我的收藏</p>
        </div>
        <p className="mt-1.5 text-xs leading-5 text-accent-800">
          已保存 <span className="font-bold">{savedCount}</span> 项资源，随时回到顶部收藏夹查看。
        </p>
      </div>
    </aside>
  );
};

export default Sidebar;